import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import Button from "../../components/Button";

import NewsEvent from "./NewsEvent";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

function Home() {
  return (
    <>
      <Helmet>
        <title>JMIF - Empowering Future Leaders</title>
        <meta
          name="description"
          content="Welcome to Jamiatu Marawi Al-Islamia Foundation (JMIF), where
      our mission is to empower minds and build futures. We take
      great pride in our ..."
          // data-rh="true"
        />
        <meta
          name="keywords"
          content="Jamiatu Marawi Al-Islamia Foundation, JMIF, Marawi School, education "
        />
        <link rel="canonical" href="https://jmif-73f1a.web.app/" />{" "}
        <meta property="og:title" content="JMIF - Empowering Future Leaders" />{" "}
        <meta
          name="og:description"
          content="Welcome to Jamiatu Marawi Al-Islamia Foundation (JMIF), where
      our mission is to empower minds and build futures. We take
      great pride in our ..."
          // data-rh="true"
        />
        <meta property="og:image" content="/image/jmif_logo" />
        <meta property="og:url" content="https://jmif-73f1a.web.app" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className=" text-grey-normal bg-secondary-light">
        <Navbar />
        <main className="">
          {/* 1st section */}
          <div className="w-full lg:h-[500px] h-auto bg-homeBanner bg-no-repeat bg-cover bg-center laptop:px-36 md:px-16 mobileSm:px-8 px-4">
            <div className="laptopLg:w-1/2 laptop:w-[60%] laptopSm:w-3/4 w-full lg:py-16 py-12 ">
              <p
                className="leading-tight  font-montserrat lg:text-[50px] md:text-[40px] text-2xl  font-black text-shadow-custom "
                style={{ textShadow: "0 4px 4px rgba(0, 0, 0, 0.25)" }}
              >
                <span className=" text-grey-normal">
                  Empowering Minds,{" "}
                  <br className="laptopSm:hidden md:block hidden" />{" "}
                </span>
                <span className=" text-text-light"> Building Futures.</span>
              </p>
              <p className="font-notoSans md:text-sm text-xs text-grey-normal leading-5 tracking-[0.04em] font-light lg:pr-24 md:my-5 my-3">
                At{" "}
                <span className="font-bold">
                  Jamiatu Marawi Al-Islamia Foundation (JMIF)
                </span>
                , we are dedicated to providing a nurturing and challenging
                environment where students can thrive academically, socially,
                and personally. Our committed educators inspire and support each
                student to reach their full potential, fostering a love of
                learning that lasts a lifetime. Join us in our journey of
                discovery, growth, and achievement, and be a part of a community
                where every mind is empowered and every future is bright.
              </p>

              <div className="flex justify-start gap-2">
                <Button
                  text={"Enroll Now"}
                  type={"none"}
                  arrow={false}
                  navigateTo={"/contactUs"}
                />

                <Button
                  text={"Learn More"}
                  type={"outline"}
                  arrow={false}
                  navigateTo={"/about"}
                />
              </div>
            </div>
          </div>
          {/* 2nd section */}

          <div className=" responsive-padding lg:block ">
            {/* card */}
            <div className="relative lg:top-[-50px] top-[-28px]">
              <div className="w-full grid md:grid-cols-4 grid-cols-2 md:gap-x-6 gap-x-4 gap-y-2  font-montserrat font-bold laptopSm:text-2xl md:text-base text-sm text-white tracking-[0.02em]">
                <Link
                  to="/facilities"
                  className="w-full lg:h-24 md:h-[70px] h-14 border border-black rounded-[10px] flex items-center justify-center text-center bg-homeCardBg cursor-pointer"
                >
                  <span className="uppercase ">Facilities</span>
                </Link>
                <Link
                  to="/admission#scholarship-program"
                  className="w-full  lg:h-24 md:h-[70px] h-14 border border-black rounded-[10px] flex items-center justify-center text-center bg-homeCardBg cursor-pointer"
                >
                  <span className="uppercase text-center">
                    Scholarship Program
                  </span>
                </Link>
                <Link
                  to="/alumni"
                  className="w-full  lg:h-24 md:h-[70px] h-14 border border-black rounded-[10px] flex items-center justify-center text-center bg-homeCardBg cursor-pointer"
                >
                  <span className="uppercase ">Alumni</span>
                </Link>
                <Link
                  to="/about#faculty-staff"
                  className="w-full  lg:h-24 md:h-[70px] h-14 border border-black rounded-[10px] flex items-center justify-center text-center  bg-homeCardBg cursor-pointer"
                >
                  <span className="uppercase ">Faculty and Staff</span>
                </Link>
              </div>
            </div>
            <div className="relative md:py-8 py-4 md:mb-12">
              <div className="absolute top-0 left-0 md:block hidden">
                <svg
                  width="120"
                  height="120"
                  viewBox="0 0 120 120"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <line
                    x1="2.5"
                    y1="2.5"
                    x2="2.5"
                    y2="117.5"
                    stroke="#19733B"
                    strokeWidth="5"
                    strokeLinecap="round"
                  />
                  <line
                    x1="117.5"
                    y1="2.5"
                    x2="2.5"
                    y2="2.5"
                    stroke="#19733B"
                    strokeWidth="5"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div className="absolute bottom-0 right-0 md:block hidden">
                <svg
                  width="120"
                  height="120"
                  viewBox="0 0 120 120"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <line
                    x1="117.5"
                    y1="117.5"
                    x2="117.5"
                    y2="2.5"
                    stroke="#19733B"
                    strokeWidth="5"
                    strokeLinecap="round"
                  />
                  <line
                    x1="2.5"
                    y1="117.5"
                    x2="117.5"
                    y2="117.5"
                    stroke="#19733B"
                    strokeWidth="5"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div className="flex flex-col items-center gap-6">
                <h1 className="font-montserrat font-black lg:text-2xl text-xl leading-5 text-text-normal mb-2 text-center">
                  Welcome to JMIF
                </h1>
                <div className="relative flex flex-col items-center gap-4 laptop:w-[60%] md:w-3/4  w-[95%]">
                  <div className="absolute top-[-14px] left-[-42px] md:block hidden">
                    <svg
                      // width="29"
                      // height="20"
                      viewBox="0 0 29 20"
                      // fill="none"
                      className=" fill-none w-7 h-5"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M25.5 20L21.6667 13.3333C23.5 13.3333 25.0695 12.6806 26.375 11.375C27.6806 10.0694 28.3333 8.5 28.3333 6.66667C28.3333 4.83333 27.6806 3.26389 26.375 1.95833C25.0695 0.652778 23.5 0 21.6667 0C19.8333 0 18.2639 0.652778 16.9583 1.95833C15.6528 3.26389 15 4.83333 15 6.66667C15 7.30556 15.0764 7.89583 15.2292 8.4375C15.382 8.97917 15.6111 9.5 15.9167 10L21.6667 20H25.5ZM10.5 20L6.66668 13.3333C8.50001 13.3333 10.0695 12.6806 11.375 11.375C12.6806 10.0694 13.3333 8.5 13.3333 6.66667C13.3333 4.83333 12.6806 3.26389 11.375 1.95833C10.0695 0.652778 8.50001 0 6.66668 0C4.83334 0 3.2639 0.652778 1.95834 1.95833C0.652786 3.26389 9.53674e-06 4.83333 9.53674e-06 6.66667C9.53674e-06 7.30556 0.076395 7.89583 0.229174 8.4375C0.381952 8.97917 0.611118 9.5 0.916674 10L6.66668 20H10.5Z"
                        fill="#F7AACA"
                      />
                    </svg>
                  </div>
                  <div className="absolute bottom-[-14px] right-[-42px] md:block hidden">
                    <svg
                      className=" fill-none w-7 h-5"
                      viewBox="0 0 29 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.50002 20L7.33335 13.3333C5.50002 13.3333 3.93058 12.6806 2.62502 11.375C1.31946 10.0694 0.666687 8.5 0.666687 6.66667C0.666687 4.83333 1.31946 3.26389 2.62502 1.95833C3.93058 0.652778 5.50002 0 7.33335 0C9.16669 0 10.7361 0.652778 12.0417 1.95833C13.3472 3.26389 14 4.83333 14 6.66667C14 7.30556 13.9236 7.89583 13.7709 8.4375C13.6181 8.97917 13.3889 9.5 13.0834 10L7.33335 20H3.50002ZM18.5 20L22.3334 13.3333C20.5 13.3333 18.9306 12.6806 17.625 11.375C16.3195 10.0694 15.6667 8.5 15.6667 6.66667C15.6667 4.83333 16.3195 3.26389 17.625 1.95833C18.9306 0.652778 20.5 0 22.3334 0C24.1667 0 25.7361 0.652778 27.0417 1.95833C28.3472 3.26389 29 4.83333 29 6.66667C29 7.30556 28.9236 7.89583 28.7709 8.4375C28.6181 8.97917 28.3889 9.5 28.0834 10L22.3334 20H18.5Z"
                        fill="#F7AACA"
                      />
                    </svg>
                  </div>
                  <p className="text-center font-notoSans font-light italic tracking-[0.04em] md:leading-4 leading-5 lg:text-sm text-xs">
                    Welcome to Jamiatu Marawi Al-Islamia Foundation (JMIF),
                    where our mission is to empower minds and build futures. We
                    take great pride in our vibrant community of dedicated
                    educators, motivated students, and supportive families.
                    Together, we create an environment that nurtures academic
                    excellence, personal growth, and lifelong learning. I invite
                    you to explore our website and discover the many
                    opportunities and resources we offer to help each student
                    succeed.
                  </p>
                </div>
                <p className="text-center lg:w-[60%] w-[88%] font-notoSans font-light tracking-[0.04em] leading-4 lg:text-sm text-xs">
                  Warm regards,
                </p>{" "}
                <p className="text-center lg:w-[60%] w-[88%] font-notoSans font-medium  tracking-[0.04em] leading-4 lg:text-sm text-xs">
                  Datu Nasser D. Sampaco
                </p>
                <div className="mt-4">
                  <Button
                    text={"More About us"}
                    type={"outline"}
                    arrow={true}
                    navigateTo={"/about"}
                  />
                </div>
              </div>
              <div className="h-[2px] bg-text-normal w-[120px] m-auto mt-6 mb-2 rounded-sm md:hidden block" />
            </div>
          </div>
          {/* 3rd section */}
          <NewsEvent />
        </main>
        <Footer />
      </div>
    </>
  );
}

export default Home;
